module.exports = __webpack_public_path__ + "static/img/icon-mail.40ce5497.svg";